import React, { useState } from "react";
import { IonIcon, IonButton, IonButtons } from "@ionic/react";
import { star, starOutline } from "ionicons/icons";

import "./RatingItem.scss";

interface RatingProps {
    count?: number; // csillagok száma (alap: 5)
    value?: number; // kezdeti érték (alap: 0)
    onChange?: (val: number) => void; // callback értékváltáskor
    readOnly?: boolean; // ha true, kattinthatatlan
}

export const RatingItem: React.FC<RatingProps> = ({
    count = 5,
    value = 0,
    onChange,
    readOnly = false,
}) => {
    const [rating, setRating] = useState<number>(value);

    const handleClick = (i: number) => {
        if (readOnly) return;
        setRating(i);
        onChange && onChange(i);
    };

    return (
        <IonButtons className="star-rating">
            {Array.from({ length: count }, (_, idx) => {
                const i = idx + 1;
                return (
                    <IonButton
                        key={i}
                        fill="clear"
                        size="small"
                        onClick={() => handleClick(i)}
                    >
                        <IonIcon
                            icon={i <= rating ? star : starOutline}
                            // style={{ color: "#f4c150", fontSize: "1.5rem" }}
                            style={{ color: "#f4c150" }}
                        />
                    </IonButton>
                );
            })}
        </IonButtons>
    );
};
